import { TSourceManagements } from '../type/source-management'
import { customErrorResponse } from '../utility/custom-error-response'
import { request, setCustomOnResponseError, resetCustomOnResponseError } from './axios'

export const SourceManagement = {
  get: async (search_key = '', page = 1): Promise<TSourceManagements> => {
    const searchParam = search_key ? `&search=${search_key}` : ''
    const typeParam = '&logic=Patient_Source'
    const {
      data: { logic_mappings, max_page_size, page_number, total_count, total_pages },
    } = await request({
      url: `/category-classification/logic-mapping/management/?page_number=${page}${searchParam}${typeParam}`,
    })

    return {
      logic_mappings,
      max_page_size,
      page_number,
      total_count,
      total_pages,
    }
  },

  archive: async (source_name: string) => {
    const typeParam = '&logic=Patient_Source'
    setCustomOnResponseError(customErrorResponse)
    return request({
      method: 'delete',
      url: `/category-classification/logic-mapping/management/?name=${source_name}${typeParam}`,
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },
}
